import React from 'react'

import { NavLink } from 'react-router-dom'

import {
  getAddress,
  getProfileUrl,
  isWebpSupported,
} from 'helpers'

import { SiteContext } from 'context/site-context'

// import { LazyLoadImage } from 'react-lazy-load-image-component'

import './index.scss'

const TopListings = () => {
  const [ site ] = React.useContext(SiteContext)

  const getImage = i => {
    let images = site['default-logos'][site.upsellCategory]?.images?.length > 0 ?
      site['default-logos'][site.upsellCategory].images[i] :
      site['default-logos']['default'].images[0]

    if(!images){
      images = site['default-logos']['default'].images[0]
    }

    return isWebpSupported() ? images.imageWebP : images.image
  }

  return <React.Fragment>
    {site.topBusinesses[site.upsellCategory]?.results?.locations?.length > 0 ? <div className="top-listings-container">
      <h2>Top <span className="highlight">{site.discover[site.upsellCategory].label}</span> in {site.location}</h2>
      <div className="cards-container">
        {site.topBusinesses[site.upsellCategory].results.locations.map( (listing, i) => <div className="card" key={listing.id}>
          <a href={getProfileUrl(site, listing)}>
            <div className="image-container">
              <img src={getImage(i)} alt={listing.name} />
            </div>
            <p>{listing.name}</p>
            <address>{getAddress(listing.address)}</address>
          </a>
        </div>)}
      </div>
      <div className="actions-container">
        <NavLink to={`/results?term=${site.upsellCategory}&where=${site.location}${!!new URLSearchParams(window.location.search).get('useSampleData') ? '&useSampleData=true' : ''}`} className="button-trigger">Explore top {site.discover[site.upsellCategory].label}</NavLink>
      </div>
    </div> : null}
  </React.Fragment>
}

export default TopListings
